module.exports = __webpack_public_path__ + "img/Stripe.2d495ea3.svg";